// Import performance utilities
import { performanceMonitor, debounce, throttle } from "./performance.js";

// Main entry point for theme JavaScript
import initHeroSwiper from "./hero-swiper.js";
import initTestimonialSwiper from "./testimonial-swiper.js";

console.log("TBF Base Theme initialized");

// Mark performance timing
performanceMonitor.mark("theme-init-start");

// Lazy load heavy libraries only when needed
const loadGSAP = () => {
  return import("./gsap.js").then((module) => module.default);
};

// Initialize theme functionality
document.addEventListener("DOMContentLoaded", function () {
  console.log("Theme loaded and ready");

  // Mark DOM ready
  performanceMonitor.mark("dom-ready");

  // Example: Only load GSAP if there are elements that need animation
  const animatedElements = document.querySelectorAll("[data-animate]");
  if (animatedElements.length > 0) {
    loadGSAP().then((gsap) => {
      console.log("GSAP loaded for animations");

      // Initialize animations with intersection observer for performance
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.fadeIn(entry.target);
            observer.unobserve(entry.target);
          }
        });
      });

      animatedElements.forEach((el) => observer.observe(el));
    });
  }

  // Example: Only load gradient if there's a gradient canvas
  const gradientCanvas = document.querySelector("[data-gradient]");
  if (gradientCanvas) {
    loadGradient().then(() => {
      console.log("Gradient animation loaded");
      // Initialize your gradient animation here
    });
  }

  // Optimize scroll events with throttling
  const handleScroll = throttle(() => {
    // Add scroll-based functionality here
    const scrollY = window.scrollY;
    document.documentElement.style.setProperty("--scroll-y", `${scrollY}px`);
  }, 16); // ~60fps

  window.addEventListener("scroll", handleScroll, { passive: true });

  // Optimize resize events with debouncing
  const handleResize = debounce(() => {
    // Add resize-based functionality here
    const viewportWidth = window.innerWidth;
    document.documentElement.style.setProperty(
      "--viewport-width",
      `${viewportWidth}px`,
    );
  }, 250);

  window.addEventListener("resize", handleResize);

  initHeroSwiper();
  initTestimonialSwiper();

  performanceMonitor.mark("theme-init-end");
  performanceMonitor.measure(
    "theme-initialization",
    "theme-init-start",
    "theme-init-end",
  );
});

// Performance monitoring (remove in production)
if (process.env.NODE_ENV === "development") {
  // Monitor performance in development
  window.addEventListener("load", function () {
    const loadTime = performanceMonitor.getPageLoadTime();
    console.log("Page fully loaded in", loadTime, "ms");

    // Get First Contentful Paint
    performanceMonitor.getFCP().then((fcp) => {
      console.log("First Contentful Paint:", fcp, "ms");
    });
  });
}
